import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { ThreeDots } from 'react-bootstrap-icons';
import { useGetCategoriesQuery } from "../../../features/CallApi";
import LoadScreen from "../../UI/LoadScreen";
import { CategoriesAdd } from "./CategoriesAdd";

export const Categories = () => {
    const navigate = useNavigate();
    const { isLoading, data, refetch, error, isFetching } = useGetCategoriesQuery();
    useEffect(() => {
        refetch()
    }, [])

    return (
        <Container>
            <h3>Категории товаров</h3>
            {error ?
                <div>{error && error.data}</div>
                :
                <div>
                    {isLoading ?
                        <LoadScreen />
                        :
                        <div>
                            <CategoriesAdd refetch={refetch} />
                            <table className="w-100 table table-hover">
                                <thead>
                                    <tr>
                                        <th className="pe-3 ps-3">Id</th>
                                        <th>Название</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.length > 0 ?
                                        data.map(categorie =>
                                            <tr key={categorie.id}>
                                                <td className="pe-3 ps-3">{categorie.id}</td>
                                                <td className="w-100">{categorie.name}</td>
                                                <td>
                                                    <UncontrolledDropdown>
                                                        <DropdownToggle color="light" >
                                                            <ThreeDots className='' size='14' />
                                                        </DropdownToggle>
                                                        <DropdownMenu container="body">
                                                            <DropdownItem onClick={() => navigate('edit/' + categorie.id)}>Изменить</DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>
                                                </td>
                                            </tr>
                                        ) :
                                        <tr>
                                            <td colSpan={3} className={"text-center"}>Список пуст</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    }
                </div>
            }
        </Container>
    )
}